import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';

/**
 * Root reducer - combines all slice reducers.
 * Add new feature reducers here as the app grows.
 */
const rootReducer = combineReducers({
  auth: authReducer,
});

export default rootReducer;
